<template>
    <f7-page>
        <f7-navbar title="Menu"></f7-navbar>
        <f7-list>
            <f7-list-item link="/todo" view="#main-view" panel-close title="Todo list"></f7-list-item>
            <f7-list-item link="/addevent" view="#main-view" panel-close title="Add Event"></f7-list-item>
            <f7-list-item link="/editevent" view="#main-view" panel-close title="Edit Event"></f7-list-item>
        </f7-list>
        <f7-list>
            <f7-list-item @click="logout" view="#main-view" panel-close title="Logout"></f7-list-item>
        </f7-list>
    </f7-page>
</template>

<script>
    export default {
        methods: {
            logout() {
                this.$store.commit('admin/logoutUser');
                this.$f7.panel.close();
                this.$f7.views.main.router.navigate('/login');
            }
        }
    }
</script>